/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleTeaser from 'base/components/labrador/ArticleTeaser';

export const DynamicLabradorArticleTeaser: typeof LabradorArticleTeaser = (props) => {
    return <ErrorBoundary><LabradorArticleTeaser {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleTeaserProps = PropsFromComponent<typeof LabradorArticleTeaser>;
